<template>
  <div>
    <v-card-title class="align-start">
      <div>
        <p class="mb-2">
          Opções selecionadas do BOT
        </p>
      </div>
    </v-card-title>
    <v-treeview
      :items="dadosBot"
      item-key="id"
      item-text="texto"
      item-children="nosFilhos"
      transition
      :open.sync="open"
      :active.sync="activeItems"
      @update:active="handleActiveUpdate"
    >
      <template
        v-slot:label="{ item }"
      >
        <div
          class="d-flex"
        >
          <span
            v-if="item.texto"
            class="text-truncate"
          >
            {{ item.numero }} - {{ item.texto }}
          </span>
          <span
            v-if="item.botaoOpcaoTitle"
            class="text-truncate"
          >
            {{ item.numero }} - {{ item.botaoOpcaoTitle }}
          </span>
          <span
            v-if="item.listaOpcaoTitle"
            class="text-truncate"
          >
            {{ item.numero }} - {{ item.listaOpcaoTitle }}
          </span>
          <v-tooltip
            top
            color="primary"
          >
            <template
              v-slot:activator="{ on, attrs }"
            >
              {{ item.qtdeEscolhidasNo }}
              <v-icon
                dense
                v-bind="attrs"
                class="cursor-pointer mx-2"
                v-on="on"
              >
                {{ icons.mdiEyeOutline }}
              </v-icon>
            </template>
            <span>Vezes que o nó foi selecionado</span>
          </v-tooltip>
        </div>
      </template>
    </v-treeview>
  </div>
</template>

<script>
import { mdiEyeOutline } from '@mdi/js'

export default {
  props: {
    dadosBot: {
      type: Array,
      default: () => [],
      required: true,
    },
  },

  data() {
    return {
      activeItems: [],
      open: [],
    }
  },

  methods: {
    handleActiveUpdate(item) {
      this.activeItems = item
    },
  },

  setup() {
    return {

      // Icons
      icons: {
        mdiEyeOutline,
      },
    }
  },

}
</script>
